import * as t from 'ts-schema';
import { defineMessage } from 'magpie-lib/models';

// Schema for bookmark operations - only needs path
const bookmarkPayloadSchema = t.object({
  path: t.string
});

// Response schema for add operations - includes full bookmark data
const addBookmarkResponseSchema = t.object({
  path: t.string,
  id: t.optional(t.string),
  label: t.optional(t.string),
  icon: t.optional(t.string)
});

// Response schema for remove operations - only needs path
const removeBookmarkResponseSchema = t.object({
  path: t.string
});

// Union schema for bookmarkChanged responses
const bookmarkResponseSchema = t.union(addBookmarkResponseSchema, removeBookmarkResponseSchema);
export let BookmarkAction;
(function (BookmarkAction) {
  BookmarkAction["ADD"] = "ADD";
  BookmarkAction["REMOVE"] = "REMOVE";
})(BookmarkAction || (BookmarkAction = {}));
const bookmarkActionSchema = t.union(t.literal(BookmarkAction.ADD), t.literal(BookmarkAction.REMOVE));
const bookmarkChanged = defineMessage({
  type: 'bookmark-changed',
  payloadSchema: t.object({
    action: bookmarkActionSchema,
    success: t.boolean,
    bookmark: bookmarkResponseSchema,
    failureReason: t.optional(t.string)
  })
});
const addBookmark = defineMessage({
  type: 'add-bookmark',
  payloadSchema: bookmarkPayloadSchema,
  reply: bookmarkChanged
});
const removeBookmark = defineMessage({
  type: 'remove-bookmark',
  payloadSchema: bookmarkPayloadSchema,
  reply: bookmarkChanged
});
export const bookmarksApi = {
  addBookmark,
  removeBookmark,
  bookmarkChanged
};